const normal = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase().replace(/[-_]/g,' ');
function initialize(root) {
  root.querySelectorAll('[data-ol-catalog]').forEach(catalog => {
    if (catalog.dataset.discoveryReady) return;
    catalog.dataset.discoveryReady = '1';
    const field = catalog.querySelector('[data-ol-catalog-search]');
    const clear = catalog.querySelector('[data-ol-catalog-clear]');
    const count = catalog.querySelector('[data-ol-catalog-count]');
    const empty = catalog.querySelector('[data-ol-catalog-empty]');
    const cards = Array.from(catalog.querySelectorAll('[data-ol-catalog-item]')).map(item=>({item,text:normal(item.dataset.olCatalogItem),platform:normal(item.dataset.olCatalogPlatform||'')}));
    const platforms=catalog.querySelector('[data-ol-platform-filters]');
    let platform='all';
    if (!field || !clear || !count || !empty) return;
    const filter = () => {
      const terms = normal(field.value).trim().split(/\s+/).filter(Boolean);
      let total = 0;
      cards.forEach(({item,text,platform:available}) => { const show = terms.every(term=>text.includes(term))&&(platform==='all'||available.includes(platform)); item.hidden = !show; if(show)total++; });
      count.textContent = count.dataset.template.replace('{n}',String(total));
      empty.hidden = total !== 0;
      clear.disabled = !field.value&&platform==='all';
    };
    if(platforms){
      const buttons=Array.from(platforms.querySelectorAll('[data-ol-platform]'));
      buttons.forEach(button=>{button.hidden=button.dataset.olPlatform!=='all'&&!cards.some(card=>card.platform.includes(button.dataset.olPlatform));});
      platforms.hidden=buttons.filter(button=>!button.hidden).length<3;
      platforms.addEventListener('click',event=>{const button=event.target.closest('[data-ol-platform]');if(!button)return;platform=button.dataset.olPlatform;buttons.forEach(item=>item.setAttribute('aria-pressed',String(item===button)));filter();});
    }
    catalog.querySelector('[data-ol-catalog-search-wrap]').hidden = false;
    count.hidden = false;
    field.addEventListener('input',filter);
    field.addEventListener('search',filter);
    clear.addEventListener('click',()=>{field.value='';platform='all';platforms?.querySelectorAll('[data-ol-platform]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.olPlatform==='all')));filter();field.focus();});
    filter();
  });
  root.querySelectorAll('[data-ol-print]').forEach(button=>{
    if(button.dataset.discoveryReady||typeof window.print!=='function')return;
    button.dataset.discoveryReady='1';button.hidden=false;
    button.addEventListener('click',()=>window.print());
  });
  root.querySelectorAll('[data-ol-reading]').forEach(contents=>{
    if(contents.dataset.discoveryReady)return;
    contents.dataset.discoveryReady='1';
    const guide=contents.closest('.ol-an');
    const headings=Array.from(guide?.querySelectorAll('.ol-an__text h2')||[]);
    if(headings.length<2)return;
    const list=contents.querySelector('[data-ol-reading-list]');
    headings.forEach((heading,index)=>{
      if(!heading.id)heading.id=`guide-topic-${index+1}`;
      heading.classList.add('ol-reading-target');
      const item=document.createElement('li');const link=document.createElement('a');
      link.href='#'+heading.id;
      const label=heading.cloneNode(true);label.querySelectorAll('.ol-an__nr').forEach(node=>node.remove());
      link.textContent=label.textContent.trim();
      item.append(link);list.append(item);
    });
    contents.hidden=false;
    list.addEventListener('click',event=>{if(event.target.closest('a'))contents.open=false;});
  });
  root.querySelectorAll('[data-ol-jump]').forEach(nav=>{
    if(nav.dataset.discoveryReady)return;
    nav.dataset.discoveryReady='1';
    const links=Array.from(nav.querySelectorAll('a[href^="#"]'));
    const targets=links.map(link=>document.getElementById(link.hash.slice(1))).filter(Boolean);
    if(!('IntersectionObserver' in window))return;
    const wrapper=document.querySelector('.page-wrapper');
    const scrollRoot=wrapper&&/auto|scroll/.test(getComputedStyle(wrapper).overflowY)?wrapper:null;
    const observer=new IntersectionObserver(entries=>{
      const active=entries.filter(entry=>entry.isIntersecting).sort((a,b)=>a.boundingClientRect.top-b.boundingClientRect.top)[0];
      if(!active)return;
      links.forEach(link=>{if(link.hash==='#'+active.target.id)link.setAttribute('aria-current','location');else link.removeAttribute('aria-current');});
    },{root:scrollRoot,rootMargin:'-15% 0px -55% 0px',threshold:0});
    targets.forEach(target=>observer.observe(target));
    document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(nav))observer.disconnect();},{once:true});
  });
  root.querySelectorAll('[data-ol-product-context]').forEach(context=>{
    if(context.dataset.discoveryReady)return;
    context.dataset.discoveryReady='1';
    const params=new URLSearchParams(location.search);
    const name=(params.get('ol_product')||'').trim().slice(0,220);
    const path=params.get('ol_path')||'';
    if(!name||!/^\/(?:[a-z]{2}(?:-[A-Za-z]{2})?\/)?products\/[a-z0-9-]+$/.test(path))return;
    context.textContent=context.dataset.label+' '+name;
    context.hidden=false;
    const field=context.closest('form')?.querySelector('[data-ol-product-field]');
    if(field){field.disabled=false;field.value=name+' — '+new URL(path,location.origin).href;}
  });
}
initialize(document);
document.addEventListener('shopify:section:load',event=>initialize(event.target));
